import React from "react";
import logo from "../../assets/image/logo-sinFondo.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { faMapMarkerAlt } from "@fortawesome/free-solid-svg-icons";

const Header = () => {
  return (
    <header className="relative bg-gradient-to-br from-gray-50 via-gray-100 to-gray-200">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-20">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%236b7280' fill-opacity='0.1'%3E%3Ccircle cx='30' cy='30' r='1'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }}></div>
      </div>

      <div className="relative z-10 py-6 px-3 flex flex-col">
        {/* Logo and Contact Info Container */}
        <div className="flex flex-col sm:flex-row justify-between items-center space-y-3 sm:space-y-0">
          
          {/* Location - Left on Desktop, Hidden on Mobile */}
          <div className="group order-1 sm:order-1 hidden sm:block">
            <a
              href="https://maps.app.goo.gl/VMx4R53qjSQyTyhi7"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center text-xs sm:text-sm font-medium text-gray-700 hover:text-gray-900 transition-colors duration-300"
            >
              <div className="flex items-center space-x-2 bg-white/90 backdrop-blur-sm px-3 py-2 rounded-full shadow-md hover:shadow-lg transform hover:scale-105 transition-all duration-300 border border-gray-300">
                <div className="w-8 h-8 bg-gradient-to-r from-red-500 to-red-600 rounded-full flex items-center justify-center shadow-md">
                  <FontAwesomeIcon
                    icon={faMapMarkerAlt}
                    className="text-white text-xl"
                  />
                </div>
                <span className="font-semibold text-gray-800">35 nro° 566 e/ 6 y 7</span>
              </div>
            </a>
          </div>

          {/* Logo Section - Center */}
          <div className="flex justify-center items-center order-2 sm:order-2">
            <a
              onClick={() => (window.location.href = "/")}
              className="block cursor-pointer group"
            >
              <div className="relative">
                {/* Logo Glow Effect */}
                <div className="absolute inset-0 bg-gradient-to-r from-gray-600 to-gray-800 rounded-full opacity-0 group-hover:opacity-15 blur-xl transition-opacity duration-300"></div>
                
                <img
                  src={logo}
                  alt="Logo Tortone"
                  className="relative w-[120px] md:w-[160px] h-auto transform group-hover:scale-105 transition-transform duration-300 drop-shadow-lg"
                  width={160}
                  height={120}
                />
              </div>
            </a>
          </div>

          {/* WhatsApp - Right on Desktop, Hidden on Mobile */}
          <div className="group order-3 sm:order-3 hidden sm:block">
            <a
              href="https://walink.co/f717a6"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center text-xs sm:text-sm font-medium text-gray-700 hover:text-gray-900 transition-colors duration-300"
            >
              <div className="flex items-center space-x-2 bg-white/90 backdrop-blur-sm px-3 py-2 rounded-full shadow-md hover:shadow-lg transform hover:scale-105 transition-all duration-300 border border-gray-300">
                <div className="w-8 h-8 bg-gradient-to-r from-green-500 to-green-600 rounded-full flex items-center justify-center shadow-md">
                  <FontAwesomeIcon
                    icon={faWhatsapp}
                    className="text-white text-xl"
                  />
                </div>
                <span className="font-semibold text-gray-800">221-6703602</span>
              </div>
            </a>
          </div>
        </div>

        {/* Mobile Contact Icons - Only visible on mobile */}
        <div className="flex justify-center items-center space-x-4 mt-3 sm:hidden">
          {/* Location Icon Only */}
          <a
            href="https://maps.app.goo.gl/VMx4R53qjSQyTyhi7"
            target="_blank"
            rel="noopener noreferrer"
            className="group"
          >
            <div className="w-10 h-10 bg-gradient-to-r from-red-500 to-red-600 rounded-full flex items-center justify-center shadow-lg hover:shadow-xl transform hover:scale-110 transition-all duration-300">
              <FontAwesomeIcon
                icon={faMapMarkerAlt}
                className="text-white text-lg"
              />
            </div>
          </a>

          {/* WhatsApp Icon Only */}
          <a
            href="https://walink.co/f717a6"
            target="_blank"
            rel="noopener noreferrer"
            className="group"
          >
            <div className="w-10 h-10 bg-gradient-to-r from-green-500 to-green-600 rounded-full flex items-center justify-center shadow-lg hover:shadow-xl transform hover:scale-110 transition-all duration-300">
              <FontAwesomeIcon
                icon={faWhatsapp}
                className="text-lg text-white"
              />
            </div>
          </a>
        </div>
      </div>
    </header>
  );
};

export default Header;